import React, { useState, useEffect } from "react";
import axiosInstance from "../axiosinstance";
import "./SubsidiaryReport.css";
import "./Table.css";

function SubsidiaryReport({ isSidebarExpanded }) {
  const [subsidiaryData, setSubsidiaryData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(
          "/api/invoice_generated_for_each_subsidiary"
        );
        console.log("Subsidiary Report Response:", response.data);
        setSubsidiaryData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching subsidiary data:", error);
        setSubsidiaryData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    
    <div
      className={`sub-report-container oa-attached-panel ${isSidebarExpanded ? "sub-report-expanded" : "sub-report-collapsed"
        }`}
    >
      <div className="table-header oa-attached-panel__header-cap">
  <div className="table-header-content">

    {/* LEFT SIDE */}
    <div className="table-left-side">
      <h2 className="jost-bold">Subsidiary Report Overview</h2>
    </div>

    {/* RIGHT SIDE (empty to maintain layout) */}
    <div className="table-right-side"></div>

  </div>
</div>
      <div className="sub-report-wrapper oa-attached-panel__body">
        <p className="sub-report-subtitle">
          Summary of invoice generation, payments, billing, received and outstanding amount by subsidiary.
        </p>

        {loading ? (
          <p className="sub-report-loading">Loading data...</p>
        ) : (
          <div className="data-list-scroll-body sub-report-table-card">
            {/* <div className="data-list-table"> */}
              <table className="table multilevel-data df-txt-left sub-report-modern-table" style={{ tableLayout: 'fixed', width: '100%' }}>
                <thead className="sticky-header">
                  <tr className="table-row">
                    <th className="center-align se-no-column">Sr. No</th>
                    <th><span style={{
                      textAlign: 'left',
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                      
                    }}>Subsidiary Name</span></th>
                    <th className="center-align" >Invoices Generated</th>
                    <th className="center-align" >Payments</th>
                    <th className="center-align price-left-align" >Total Billing (₹)</th>
                    <th className="center-align price-left-align" >Total Received (₹)</th>
                    <th className="center-align price-left-align" >
                      Total Outstanding (₹)
                    </th>
                  </tr>
                </thead>
                <tbody style={{ backgroundColor: "#fff" }}>
                  {subsidiaryData.length > 0 ? (
                    subsidiaryData.map((item, idx) => (
                      <tr key={item.subsidiary_id || idx} className="table-row hoverable-row sub-td">
                        <td className="center-align">{idx + 1}</td>
                        <td>
                          {item.subsidiary_name
                            ? item.subsidiary_name
                              .toLowerCase()
                              .split(' ')
                              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                              .join(' ')
                            : "—"}
                        </td>
                        <td className="center-align">
                          {item.invoice_generated ?? "—"}
                        </td>
                        <td className="center-align">
                          {item.payment_count ?? "—"}
                        </td>
                        <td className="center-align price-left-align sub-report-amount sub-report-billing">
                          ₹{(item.total_billing ?? 0).toLocaleString("en-IN")}
                        </td>
                        <td className="center-align price-left-align sub-report-amount sub-report-received">
                          ₹{(item.total_received ?? 0).toLocaleString("en-IN")}
                        </td>
                        <td
                          className={`sub-report-cell-count center-align price-left-align sub-report-amount sub-report-outstanding ${(item.total_outstanding ?? 0) < 0
                            ? "negative-outstanding"
                            : "positive-outstanding"
                            }`}
                        >
                          ₹{(item.total_outstanding ?? 0).toLocaleString("en-IN")}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="sub-report-no-data">
                        No subsidiaries found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            {/* </div> */}
          </div>
        )}
      </div>
    </div>
  );
}

export default SubsidiaryReport;
